import { CustomerSelection } from './CustomerSelection';
import { SubscriptionReviewPage } from './SubscriptionReview';
import { PackageSelection } from '~/shared/components/PackageSelection';

export const Pages = [PackageSelection, CustomerSelection, SubscriptionReviewPage] as const;
